/* eslint-disable no-restricted-imports */
import { Box } from '@mui/material';
import { FC } from 'react';
import { AccountInformationForm } from '@/components/content/Account/parts/InformationForm';
import { AccountPersonalFrameSX } from '@/components/content/Account/styles/accountPersonal';
import { PersonalFormSkeleton } from '@/components/content/Account/parts/Skeletons/PersonalFormSkeleton';
import { useDpValeUser } from '@/data/Content/Dpvale';
import { DpvaleUser } from 'integration/generated/transactions/data-contracts';

export const AccountPersonal: FC = () => {
	const { data, isLoading, mutate } = useDpValeUser();

	if (isLoading) {
		return <PersonalFormSkeleton />;
	}

	return (
		<Box sx={AccountPersonalFrameSX}>
			<AccountInformationForm
				personInfo={data || ({} as DpvaleUser)}
				isLoading={isLoading}
				onMutatePersonInfo={mutate}
			/>
		</Box>
	);
};
